export default {"src":"/_next/static/media/Fibroids and Ovarian Cysts.f0392c7d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};